(function () {
    'ngInject';

    angular.module('app.shared.services').service('ConfigService', configService);

    function configService() {
        let currentOriginalPath = '';

        const dev = {
            // Set the corresponding apiBaseURL to point to the server
            apiBaseURL: window.location.origin + '/api',
            redirectedFrom: null,
            customilyOptionsUrl: process.env.VUE_APP_CUSTOMILY_OPTIONS_URL,
            MAX_PREVIEW_IMAGE_SIZE: 1200,
            cloudFrontUrl: process.env.VUE_APP_CLOUDFRONT_URL,
            openRoutes: [
                '/signin',
                '/signup',
                '/affiliates/signup',
                '/verify',
                '/forgotPassword',
                '/passwordReset',
                '/invalidStore',
                '/emailConfirmation',
                '/stamp/:stampId/:redirectTo?'
            ]
        };

        function setCurrentOriginalPath(aPath) {
            currentOriginalPath = aPath;
        }

        function getCurrentOriginalPath() {
            return currentOriginalPath;
        }

        return {
            dev: dev,
            customilyOptionsUrl: dev.customilyOptionsUrl,
            apiBaseURL: dev.apiBaseURL,
            redirectedFrom: dev.redirectedFrom,
            MAX_PREVIEW_IMAGE_SIZE: dev.MAX_PREVIEW_IMAGE_SIZE,
            cloudFrontUrl: dev.cloudFrontUrl,
            openRoutes: dev.openRoutes,
            setCurrentOriginalPath: setCurrentOriginalPath,
            getCurrentOriginalPath: getCurrentOriginalPath
        };
    }
})();
